// src/components/ui/CoreValues.jsx
import React from "react";
import { motion } from "framer-motion";

const valori = [
  {
    text: "Sacralul tău e busola. Nu teoria.",
    borderColor: "border-brand-turcoaz",
  },
  {
    text: "Vindecarea nu se grăbește – dar cere adevăr.",
    borderColor: "border-brand-lavanda",
  },
  {
    text: "Fiecare design trăit deschide o poartă.",
    borderColor: "border-brand-lavanda_intensa",
  },
];

export default function CoreValues() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-10 text-sm text-text-body">
      {valori.map((val, index) => (
        <motion.div
          key={index}
          whileHover={{ scale: 1.05 }}
          className={`bg-white/80 backdrop-blur-md shadow-md p-4 rounded-xl transition duration-300 border ${val.borderColor}`}
        >
          {val.text}
        </motion.div>
      ))}
    </div>
  );
}
